export const translations = {
  en: {
    nav: {
      home: "Home",
      headhunter: "AI Headhunter",
      platforms: "For Platforms",
      vision: "Vision",
      tools: "Utilities",
      cta: "Try the AI Headhunter"
    },
    legal: {
      privacyTitle: "Privacy Policy",
      cookieTitle: "Cookie Policy",
      termsTitle: "Terms of Service"
    },
    cookieBanner: {
      text: "We use cookies to improve the performance of vacature.ai and analyze website traffic. By clicking Accept you agree to the use of cookies as described in our ",
      linkText: "Cookie Policy",
      accept: "Accept",
      decline: "Decline"
    },
    home: {
      hero: {
        tagline: "Explainable AI for job matching.",
        headline: "AI that understands jobs and talent.",
        subtext: "Upload your CV and discover explainable job matches, skill gaps, and new career paths.",
        primaryCta: "Try the AI Headhunter",
        secondaryCta: "How it works"
      },
      engine: {
        title: "The AI Matching Engine",
        subtitle: "Our 4-step matching framework",
        step1: "CV Analysis",
        step1Desc: "Extraction of skills and experience into a structured profile.",
        step2: "Job Analysis",
        step2Desc: "Deep parsing of requirements and organizational context.",
        step3: "Semantic Matching",
        step3Desc: "Advanced comparison beyond simple keywords.",
        step4: "Explainable Score",
        step4Desc: "Transparent feedback on why you fit or what's missing."
      },
      example: {
        title: "Match Insight Example",
        score: "Match score",
        strong: "Strong skills",
        gaps: "Skill gaps",
        alt: "Alternative roles"
      }
    },
    headhunter: {
      title: "AI Headhunter",
      subtitle: "Discover your path based on your professional DNA.",
      label: "Step 1: Activate CV",
      upload: "Upload CV (PDF/DOCX)",
      placeholder: "Or paste your CV content here...",
      cta: "Start Analysis",
      analyzing: "Processing data...",
      gretaTitle: "Hi, I'm Vacature.ai.",
      gretaText: "I'll help you explain the insights found in your CV.",
      domain: "Identified Domain",
      skills: "Recognized Skills",
      opportunities: "Found Opportunities",
      viewJob: "View Vacancy",
      disclaimer: "The information shown is derived from the input text. Greta supports the explanation of this data.",
      aiDisclaimerTitle: "AI Disclaimer",
      aiDisclaimerText: "Vacature.ai uses artificial intelligence to analyze CV information and generate career insights. The results provided by the platform are suggestions based on algorithmic analysis and should not be interpreted as professional career advice or guaranteed job matches. Users are responsible for verifying the accuracy of the information in their CV and evaluating any suggested opportunities."
    },
    vision: {
      title: "Our Vision",
      privacyTitle: "Privacy & Security",
      privacyText: "Your CV is securely stored so you can track match insights and career recommendations. Vacature.ai is built with privacy-conscious infrastructure and secure cloud storage.",
      talentTitle: "AI that works for you",
      talentText: "Most recruitment AI is built to filter candidates for employers. Vacature.ai is for the talent. It is your personal advisor helping you find clarity in a complex market."
    },
    footer: {
      tagline: "Explainable AI for job matching.",
      headhunter: "AI Headhunter",
      start: "Start Headhunter",
      possibilities: "Possibilities",
      vision: "Vision",
      tools: "Tools",
      match: "Vacancy Match",
      letter: "Motivation Letter",
      linkedin: "LinkedIn Check",
      trainer: "Interview Trainer",
      org: "Organization",
      about: "About Us",
      contact: "Contact",
      privacyPolicy: "Privacy Policy",
      cookiePolicy: "Cookie Policy",
      termsOfService: "Terms of Service",
      copyright: "© 2026 Vacature.ai. Privacy-first Career AI."
    }
  },
  nl: {
    nav: {
      home: "Home",
      headhunter: "AI Headhunter",
      platforms: "Voor Platforms",
      vision: "Visie",
      tools: "Hulpstukken",
      cta: "Probeer de AI Headhunter"
    },
    legal: {
      privacyTitle: "Privacybeleid",
      cookieTitle: "Cookiebeleid",
      termsTitle: "Algemene Voorwaarden"
    },
    cookieBanner: {
      text: "Wij gebruiken cookies om de prestaties van vacature.ai te verbeteren en websiteverkeer te analyseren. Door op Accepteren te klikken gaat u akkoord met het gebruik van cookies zoals beschreven in ons ",
      linkText: "Cookiebeleid",
      accept: "Accepteren",
      decline: "Weigeren"
    },
    home: {
      hero: {
        tagline: "Begrijpelijke AI voor vacature-matching.",
        headline: "AI die werk en talent begrijpt.",
        subtext: "Upload je CV en ontdek transparante matches, ontbrekende vaardigheden en nieuwe loopbaanpaden.",
        primaryCta: "Probeer de AI Headhunter",
        secondaryCta: "Hoe het werkt"
      },
      engine: {
        title: "De AI Matching Engine",
        subtitle: "Ons matching-framework in 4 stappen",
        step1: "CV Analyse",
        step1Desc: "Extractie van vaardigheden en ervaring naar een gestructureerd profiel.",
        step2: "Vacature Analyse",
        step2Desc: "Diepe analyse van vereisten en de organisatorische context.",
        step3: "Semantische Match",
        step3Desc: "Geavanceerde vergelijking die verder gaat dan trefwoorden.",
        step4: "Begrijpelijke Score",
        step4Desc: "Transparante feedback over waarom je past of wat er ontbreekt."
      },
      example: {
        title: "Voorbeeld Match Inzicht",
        score: "Match score",
        strong: "Sterke punten",
        gaps: "Ontbrekende skills",
        alt: "Alternatieve rollen"
      }
    },
    headhunter: {
      title: "AI Headhunter",
      subtitle: "Ontdek je pad op basis van je professionele DNA.",
      label: "Stap 1: CV Activeren",
      upload: "Upload CV (PDF/DOCX)",
      placeholder: "Of plak hier de inhoud van je CV...",
      cta: "Start Analyse",
      analyzing: "Gegevens worden verwerkt...",
      gretaTitle: "Hoi, ik ben Vacature.ai.",
      gretaText: "Ik help je bij het toelichten van de gegevens die naar voren komen uit je CV.",
      domain: "Vastgesteld Domein",
      skills: "Herkende Vaardigheden",
      opportunities: "Gevonden kansen",
      viewJob: "Bekijk Vacature",
      disclaimer: "De getoonde informatie is voortgekomen uit de ingevoerde tekst. Greta ondersteunt bij het toelichten van deze gegevens.",
      aiDisclaimerTitle: "AI Disclaimer",
      aiDisclaimerText: "Vacature.ai maakt gebruik van kunstmatige intelligentie om CV-informatie te analyseren en loopbaaninrichting te genereren. De resultaten die door het platform worden verstrekt, zijn suggesties op basis van algoritmische analyse en mogen niet worden geïnterpreteerd als professioneel loopbaanadvies of gegarandeerde vacature-matches. Gebruikers zijn verantwoordelijk voor het verifiëren van de juistheid van de informatie in hun CV en het evalueren van gesuggereerde kansen."
    },
    vision: {
      title: "Onze Visie",
      privacyTitle: "Privacy & Veiligheid",
      privacyText: "Je CV wordt veilig opgeslagen, zodat je match-inzichten en loopbaanaanbevelingen kunt volgen. Vacature.ai is gebouwd met privacybewuste infrastructuur en beveiligde cloudopslag.",
      talentTitle: "AI dat works for you",
      talentText: "De meeste recruitment AI is gebouwd om kandidaten te filteren voor werkgevers. Vacature.ai is voor het talent. Het is jouw persoonlijke advisor die je helpt helderheid te vinden."
    },
    footer: {
      tagline: "Begrijpelijke AI voor vacature-matching.",
      headhunter: "AI Headhunter",
      start: "Start Headhunter",
      possibilities: "Mogelijkheden",
      vision: "Visie",
      tools: "Tools",
      match: "Vacature-match",
      letter: "Motivatiebrief",
      linkedin: "LinkedIn-check",
      trainer: "Interview Trainer",
      org: "Organisatie",
      about: "Over ons",
      contact: "Contact",
      privacyPolicy: "Privacybeleid",
      cookiePolicy: "Cookiebeleid",
      termsOfService: "Algemene Voorwaarden",
      copyright: "© 2026 Vacature.ai. Privacy-first Career AI."
    }
  }
};